// extracted by mini-css-extract-plugin
module.exports = {"managmentOc":"styles_managmentOc__17EOa","options":"styles_options__3CUcS","checkBox":"styles_checkBox__1oe0N","confirmation":"styles_confirmation__2VKiC"};